@if (!isInitialized) {
  <div class="spinner-container">
    <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
  </div>
}

@if (isInitialized) {
  <div>
    @if (isPaymentMethodDropdownVisible) {
      <div class="form-group payment-method-dropdown">
        <div class="custom-select form-group">
          <select
            class="form-select"
            id="paymentMethodList"
            [ngModel]="selectedIndex"
            #paymentMethodSelect
            (change)="selectPaymentMethod(paymentMethodSelect.value)"
            [disabled]="disabled || isLoading"
          >
            @for (p of paymentMethods; track p; let i = $index) {
              <option [value]="i">
                @if (!isDirectPayment(p) && !isPayPal(p)) {
                  <span> {{ p | paymentMethod: 'summary' }} ({{ p | paymentMethod: 'expiryShort' }}) </span>
                }
                @if (isPayPal(p)) {
                  <span>
                    {{ p | paymentMethod: 'summary' }}
                  </span>
                }
                @if (isDirectPayment(p)) {
                  <span>{{ 'PAY_IN_SHOP' | translate }}</span>
                }
              </option>
            }
            <option [value]="paymentMethods.length">&lt;{{ 'NEW_PAYMENT_METHOD' | translate }}&gt;</option>
          </select>
        </div>
      </div>
    }
    <!-- Wallet payment -->
    @if (isWalletPaymentVisible) {
      <div class="mb-2">
        <!-- Apple Pay -->
        @if (isApplePayAvailable) {
          <lh-shared-ui-apple-pay-button
            [type]="isSimpleMode && isConfirmingBooking ? 'book' : 'plain'"
            [theme]="'dark'"
            [size]="isSimpleMode ? 'medium' : 'small'"
            [elevated]="false"
            [rounded]="isSimpleMode"
            [disabled]="disabled || isLoading"
            (press)="showBrowserPayment()"
          ></lh-shared-ui-apple-pay-button>
        }
        <!-- Google Pay -->
        @if (isGooglePayAvailable) {
          <lh-shared-ui-google-pay-button
            [id]="'googlePayButton'"
            [type]="isSimpleMode && isConfirmingBooking ? 'book' : 'plain'"
            [theme]="'dark'"
            [size]="isSimpleMode ? 'medium' : 'small'"
            [elevated]="false"
            [rounded]="isSimpleMode"
            [disabled]="disabled || isLoading"
            (press)="showBrowserPayment()"
          ></lh-shared-ui-google-pay-button>
        }
      </div>
    }
    <!-- PayPal payment -->
    @if (isPayPalPaymentVisible) {
      <div class="mb-2">
        <lh-shared-ui-paypal-button
          [id]="'paypalButton'"
          [type]="isSimpleMode && isConfirmingBooking ? 'book' : 'plain'"
          [theme]="'gold'"
          [size]="isSimpleMode ? 'medium' : 'small'"
          [elevated]="false"
          [rounded]="isSimpleMode"
          [logomark]="!isSimpleMode"
          [logotype]="true"
          [disabled]="disabled || isLoading"
          (press)="onPaypalClick($event)"
        ></lh-shared-ui-paypal-button>
      </div>
    }
    <!-- Payment card form -->
    @if (isPaymentCardFormVisible) {
      <div class="form-group">
        <div
          class="divider"
          [hidden]="
            isSimpleMode || (isSkipLoginVariant && !isLoggedIn) || (!isPayPalPaymentVisible && !isWalletPaymentVisible)
          "
        >
          <small class="divider-text">{{ 'OR' | translate | lowercase }}</small>
        </div>
        <lh-payment-card-input
          [isLoading]="isLoading"
          [isPrimary]="!isWalletPaymentAvailable"
          [allowCancel]="false"
          [isConfirmingBooking]="isConfirmingBooking"
          [isSimpleMode]="isSimpleMode"
          [isSubmitButtonVisible]="!isConfirmButtonHidden"
          [orderId]="orderId"
          [storageLocationId]="storageLocationId"
          [payment]="payment"
          (result)="onPaymentCardResult($event)"
          (cancel)="cancelAddPaymentCard()"
          #paymentCardInput
        ></lh-payment-card-input>
      </div>
    }
    <!-- Direct payment info -->
    @if (isDirectPaymentSelected && !isPaymentCardFormVisible) {
      <div class="form-group">
        <small>{{ 'YOU_CAN_PAY_THE_STAFF_DIRECTLY' | translate }}.</small>
      </div>
    }
    @if (isConfirmButtonVisible) {
      <button
        id="confirmPaymentMethod"
        class="btn btn-sm btn-block btn-primary"
        (click)="confirmPaymentMethod()"
        [disabled]="disabled || isLoading"
      >
        {{ confirmCallToAction | translate }}
      </button>
    }
  </div>
}
